import View from 'cdna/core/view';

export default View.extend({
    tagName: 'a',
    className: 'faq-toc',
    bindings: {
        'Name': 'attr name',
        'Title': 'text'
    },
    initialize() {
        this.$el.attr('src', '#');
    }
});



/** WEBPACK FOOTER **
 ** ./client/faq/faqLinkView.js
 **/